import {
  Avatar,
  Box,
  Card,
  Container,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import * as React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { style as styles } from "../pages/homepage"

// Import Swiper styles
import "swiper/css"
import { Autoplay, Navigation, Pagination } from "swiper"
import "swiper/css/navigation"
import "swiper/css/pagination"
import customer from "../images/about/customer.svg"

import danial from "../images/danialprofile.png"
import Will from "../images/will_marling.jpg"
import manish from "../images/Manish-Panjiar.jpg"
import cleve from "../images/CliveVaz.png"
import aaron from "../images/AaronDix.png"
import mrityunjaya from "../images/MrityunjayaP.png"
import kalyanrao from "../images/Kalyan-Rao.jpg"
import manik from "../images/manik-khurana.png"
import rahulJuware from "../images/RahulJuware.png"
import debbie from "../images/debbie.jpg"

export const style = {
  testimonialCard: {
    background: "#f7f6fb",
    padding: "25px",
    width: "33.33%",
    borderRadius: "20px",
    border: "3px solid #256aa3",
    '@media (max-width: 600px)': {
      width: "100%",
    }
  },
  wordingsBlock: {
    maxHeight: "8.5rem",
    marginBottom: 0,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#aaaaaa",
      borderRadius: "10px",
      border: "2px solid #f1f1f1",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#757575",
    },
    '@media (max-width: 600px)': {
      height: "7.2rem",
    }
  },
}
function Testimonial() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.up("md"))

  return (
    <>
      <Container maxWidth="lg">
        <Stack gap={6} sx={{ position: "relative", zIndex: 1 }} py={6}>
          <Stack
            alignItems="center"
            sx={styles.heading}
            gap={3.5}
            px={{ xs: 0, sm: 0, md: 12.5 }}
          >
            <Stack alignItems="center">
              <Typography variant="h3" className="sectHeading">
                Our Happy Customers
              </Typography>
              <Divider></Divider>
            </Stack>
          </Stack>
        </Stack>
      </Container>
      <div className="Homepage-testimonials">
        {/* mobile swiper */}

        {isMobile ? (
          <Container maxWidth="xl" className="mainWrapper positionReltive">
            <Swiper
              className="mySwiper navPaginationSwiper"
              modules={[Autoplay, Pagination, Navigation]}
              loop={true}
              autoplay={{ delay: 6000 }}
              centeredSlides={true}
              pagination={{
                clickable: true,
              }}
              navigation={false}
            >
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                        src={debbie}
                        sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Debbie Bobadilla
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Client Delivery Director, Hmara Solutions
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15} color="#514F6E">
                        "This is our first time working with Invimatic, and they've already proven to be an invaluable asset. Their expertise and reliability have kept the integration project on track and running smoothly. Highly recommend!"
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={Will}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Will Marling
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          COO and VP for SE Implementation Services, ShuffleLabs
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15} color="#514F6E">
                        "Invimatic Solutions is a great partner for development needs. Their skilled team provides cost-effective solutions and meaningful support for complex projects."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={cleve}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Clive Vaz
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Technology consulting & advisory, PeepsRide
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Working with Invimatic's team, led by Raghava and Prashant, was a privilege. They exceeded our expectations with their expertise and timely delivery."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={aaron}
                      sx={{ height: 80, width: 80}}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Aaron Dix
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Founder & CEO, BettrData.io
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Invimatic was crucial to our startup's success. They delivered high-quality work on tight deadlines and kept us informed with clear communication."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={mrityunjaya}
                      sx={{ height: 80, width: 80}}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Mrityunjaya P
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          CTO, Mai Labs
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        At Mai Labs, we've had the privilege of partnering with Invimatic on multiple projects, and their technical team has consistently impressed us. Their ability to tackle complex solutions with remarkable ease is truly commendable.
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={danial}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Daniel Somech
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Co-CEO, MailPop LLC
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Working with Invimatic on my educational platform was seamless. Their commitment to transparency and expertise resulted in a user-friendly, efficient product."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={manish}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Manish Panjiar
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Founder, Xtaas Corp
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "I highly recommend Invimatic! They are professional, deliver on time and budget, and truly care about their projects. Looking forward to future work!"
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={kalyanrao}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Kalyan Rao Bapatla
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Technology Services, Sai Systems Pvt. Ltd.
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "I’ve worked with Invimatic on a few projects, and every time, the team has strived to make sure that we are happy. I plan to continue working with Invimatic in the future."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={rahulJuware}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Rahul Juware
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Director, Social Lab Environmental Solutions Pvt. Ltd.
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "We're pleased to recommend Invimatic with a rating of 9 out of 10. They exceeded expectations. Their transparent communication, responsiveness to changes, and ownership of deliverables set them apart."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={style.testimonialCard}
                  mx="auto"
                  pt={5}
                  pr={5}
                  pb={4}
                  pl={4}
                >
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={manik}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Manik Khurana
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Founder, Disco Insights
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Invimatic understood my needs while building my website, and the team was always available to answer my questions. I met some great people, and look forward to working with them more."
                      </Typography>
                    </Box>
                </Box>
              </SwiperSlide>
            </Swiper>
          </Container>
        ) : (
          <Box className="successStoryBox">
            <Swiper
              // className="mySwiper navPaginationSwiper"
              className="mySwiper swiper-container desktopView "
              // breakpoints={{
              //   601: {
              //     slidesPerView: 1.5,
              //     spaceBetween: 14,
              //   },
              //   1024: {
              //     slidesPerView: 2.1,

              //   }
              // }}
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={14}
              loop={true}
              centeredSlides={true}
              autoplay={{ delay: 6000 }}
              navigation={true}
            >
              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="row"
                  mx="auto"
                  gap={3}
                  pt={5}
                  pr={"55px"}
                  pb={4}
                  pl={"55px"}
                >
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                        src={debbie}
                        sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Debbie Bobadilla
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Client Delivery Director, Hmara Solutions
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15} color="#514F6E">
                        "This is our first time working with Invimatic, and they've already proven to be an invaluable asset. Their expertise and reliability have kept the integration project on track and running smoothly. Highly recommend!"
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={Will}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Will Marling
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          COO and VP for SE Implementation Services, ShuffleLabs
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15} color="#514F6E">
                        "Invimatic Solutions is a great partner for development needs. Their skilled team provides cost-effective solutions and meaningful support for complex projects."
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={cleve}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Clive Vaz
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Technology consulting & advisory, PeepsRide
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Working with Invimatic's team, led by Raghava and Prashant, was a privilege. They exceeded our expectations with their expertise and timely delivery."
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </SwiperSlide>

              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="row"
                  mx="auto"
                  gap={3}
                  pt={5}
                  pr={"55px"}
                  pb={4}
                  pl={"55px"}
                >
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={aaron}
                      sx={{ height: 80, width: 80}}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Aaron Dix
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Founder & CEO, BettrData.io
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Invimatic was crucial to our startup's success. They delivered high-quality work on tight deadlines and kept us informed with clear communication."
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={mrityunjaya}
                      sx={{ height: 80, width: 80}}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Mrityunjaya P
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          CTO, Mai Labs
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        At Mai Labs, we've had the privilege of partnering with Invimatic on multiple projects, and their technical team has consistently impressed us. Their ability to tackle complex solutions with remarkable ease is truly commendable.
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={danial}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Daniel Somech
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Co-CEO, MailPop LLC
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Working with Invimatic on my educational platform was seamless. Their commitment to transparency and expertise resulted in a user-friendly, efficient product."
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </SwiperSlide>

              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="row"
                  mx="auto"
                  gap={3}
                  pt={5}
                  pr={"55px"}
                  pb={4}
                  pl={"55px"}
                >
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={manish}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Manish Panjiar
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Founder, Xtaas Corp
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "I highly recommend Invimatic! They are professional, deliver on time and budget, and truly care about their projects. Looking forward to future work!"
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={kalyanrao}
                      sx={{ height: 80, width: 80}}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Kalyan Rao Bapatla
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Technology Services, Sai Systems Pvt. Ltd.
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        I’ve worked with Invimatic on a few projects, and every time, the team has strived to make sure that we are happy. I plan to continue working with Invimatic in the future.
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={rahulJuware}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Rahul Juware
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Director, Social Lab Environmental Solutions Pvt. Ltd.
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "We're pleased to recommend Invimatic with a rating of 9 out of 10. They exceeded expectations. Their transparent communication, responsiveness to changes, and ownership of deliverables set them apart."
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </SwiperSlide>

              <SwiperSlide className="slideWidth">
                <Box
                  display="flex"
                  flexDirection="row"
                  mx="auto"
                  gap={3}
                  pt={5}
                  pr={"55px"}
                  pb={4}
                  pl={"55px"}
                >
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={manik}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Manik Khurana
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Founder, Disco Insights
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15}>
                        "Invimatic understood my needs while building my website, and the team was always available to answer my questions. I met some great people, and look forward to working with them more."
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                        src={debbie}
                        sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Debbie Bobadilla
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          Client Delivery Director, Hmara Solutions
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15} color="#514F6E">
                        "This is our first time working with Invimatic, and they've already proven to be an invaluable asset. Their expertise and reliability have kept the integration project on track and running smoothly. Highly recommend!"
                      </Typography>
                    </Box>
                  </Card>
                  <Card sx={style.testimonialCard}>
                    <Stack
                      gap={2}
                      direction="row"
                      alignItems="center"
                    >
                      <Avatar
                      src={Will}
                      sx={{ height: 80, width: 80 }}
                      ></Avatar>
                      <Stack gap={0.8}>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          color="#170F49"
                          lineHeight="normal"
                        >
                          Will Marling
                        </Typography>
                        <Typography
                          color="#6F6C90"
                          lineHeight="normal"
                          fontSize={13}
                        >
                          COO and VP for SE Implementation Services, ShuffleLabs
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      mt={2}
                      mb={2}
                      sx={style.wordingsBlock}
                    >
                      <Typography variant="body1" fontSize={15} color="#514F6E">
                        "Invimatic Solutions is a great partner for development needs. Their skilled team provides cost-effective solutions and meaningful support for complex projects."
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </SwiperSlide>
            </Swiper>
          </Box>
        )}
      </div>
    </>
  )
}

Testimonial.defaultProps = {}

Testimonial.propTypes = {}

export default Testimonial
